import React from "react";
import "./infoBox.scss";

type InfoBoxProps = {
  sede: any;
  page: string;
  changeSelectedSede: any;
  changePage: any;
};

export default function InfoBox( { sede, page, changePage, changeSelectedSede }: InfoBoxProps) {

  const handleClick = async () => {
    await changeSelectedSede(sede);
    await changePage('sede');
  }

  return (
    <div className="m-infobox__container">
      <div
        className="m-infobox__container__img"
        style={{ backgroundImage: `url(${sede.image[0].file.url})` }}
      ></div>
      <div className="m-infobox__container__info" >
        <div  className="m-infobox__container__info__name">
          {sede.name}
        </div>
        {page === "main" && (
          <div className="m-infobox__container__info__link">
            <p className="m-infobox__container__info__link--decoration" onClick={handleClick}>¿Cómo llegar?</p>
          </div>
        )}
      </div>
    </div>
  );
}
